import axios from 'axios'
let fetchStoreData = key => {
  if (window.localStorage.getItem('PMGC-default') && window.localStorage.getItem('PMGC-default') !== null) {
    return JSON.parse(JSON.parse(window.localStorage.getItem('PMGC-default')).value)[key]
  } else {
    return null
  }
}
export default () => {
  return axios.create({
    headers: {'x-access-token': fetchStoreData('token')},
    baseURL: `http://localhost:3040`
    // baseURL: `https://cbt-testing.herokuapp.com/`
  })
}



// WEBPACK FOOTER //
// ./src/services/api.js